import { faRocket } from "@fortawesome/free-solid-svg-icons";
import { format, isSameDay, subDays } from "date-fns";

export interface VersaoDto {
  id: number;
  tag: string;
  descricao: string;
  createdAt: string;
  instalador: boolean;
  backendUrl?: string;
  frontendUrl?: string;
}

export interface LinkItem {
  label: string;
  url: string;
}

export interface TimelineItem {
  id: string | number;
  time: string;
  icon: any;
  iconColor:
    | "primary"
    | "secondary"
    | "success"
    | "info"
    | "warning"
    | "danger"
    | "light"
    | "dark";
  title: string;
  content: string;
  tasker: string;
  file?: string;
  links?: LinkItem[];
}

export interface TimelineGroup {
  id: number;
  date: string;
  items: TimelineItem[];
}

const formatTimelineDate = (dateString: string): string => {
  const date = new Date(dateString);

  if (isSameDay(date, new Date())) {
    return "Hoje";
  }

  if (isSameDay(date, subDays(new Date(), 1))) {
    return "Ontem";
  }

  return format(date, 'dd MMMM, yyyy');
};

const formatTimelineTime = (dateString: string): string => {
  return format(new Date(dateString), 'HH:mm');
};

export const convertVersoesToTimelineData = (
  versoes: VersaoDto[] | undefined
): TimelineGroup[] => {
  if (!versoes || !Array.isArray(versoes)) {
    return [];
  }

  const versoesByDate: Record<string, VersaoDto[]> = versoes.reduce(
    (acc, versao) => {
      const date = formatTimelineDate(versao.createdAt);

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(versao);
      return acc;
    },
    {} as Record<string, VersaoDto[]>
  );

  return Object.entries(versoesByDate).map(([date, items], index) => {
    return {
      id: index + 1,
      date,
      items: items.map((versao, itemIndex) => {
        let content = versao.descricao;

        if (versao.backendUrl || versao.frontendUrl) {
          content += "\n\nLinks para download:";
          if (versao.backendUrl) {
            content += `\n• <a href="${versao.backendUrl}" target="_blank" rel="noopener noreferrer">Backend</a>`;
          }
          if (versao.frontendUrl) {
            content += `\n• <a href="${versao.frontendUrl}" target="_blank" rel="noopener noreferrer">Frontend</a>`;
          }
        }

        return {
          id: `${index + 1}${itemIndex + 1}`,
          time: formatTimelineTime(versao.createdAt),
          icon: faRocket,
          iconColor: "primary",
          title: `Versão ${versao.tag}${
            versao.instalador
              ? ' <span class="badge bg-success ms-2">Instalador</span>'
              : ""
          }`,
          content: content,
          tasker: "Sistema de Versões",
          links: [
            ...(versao.backendUrl
              ? [{ label: "Backend", url: versao.backendUrl }]
              : []),
            ...(versao.frontendUrl
              ? [{ label: "Frontend", url: versao.frontendUrl }]
              : []),
          ],
        };
      }),
    };
  });
};
